import { gql } from "@apollo/client"

/**
 * @deprecated for multiple_choice responseSets, still job data in the system that uses this
 */
const NUMBER_RATING_JOB_STEP_FIELDS = gql`
  fragment NumberRatingJobStepFields on NumberRatingJobStep {
    id
    step
    number
    section
    name
    hasScoring
    failed
    description
    responseType
    responseMandatory
    response
    skip
    notApplicable
    unresolvedActions
    hasResolvedActions
    completed @client
    completedAt
    completedBy {
      ...JobStepCompletedByFields
    }
    uploads {
      ...JobStepUploadsFields
    }
    notes {
      ...JobStepNotesFields
    }
  }
`

export { NUMBER_RATING_JOB_STEP_FIELDS }
